import { connect } from "react-redux";
import DeleteButton from "../../../presentational/customerItems/DeleteButton";
import { deleteSavedItem as deleteItem } from "../../../../state/actions";

const mapDispatchToProps = (dispatch, { id }) => ({
  deleteItem: () => dispatch(deleteItem({ id }))
});

export default connect(undefined, mapDispatchToProps)(DeleteButton);
